import AbstractAuthoriser from './abstract';

/**
 * @class NeonAuthoriser
 * @description Performs all neon authorisation
 */
class NeonAuthoriser extends AbstractAuthoriser {

    /**
     * Constructs the authoriser
     *
     * @example of component and component actions
     * users: {
     *    route: [
     *        UserRoles.ROLE_APPLICATION_MANAGERS,
     *        UserRoles.ROLE_CLIENT_CENTER
     *    ]
     * }
     * @param {Object} config - authoriser config
     * @param {Object} config.componentName - component configuration (see example)
     * @param {array} config.componentName.componentAction - component action allowed roles
     * @param {string} config.loginRedirect - login path
     */
    constructor(config) {
        super('neon', config);
    }
}

export default NeonAuthoriser;
